.prism-search {
	display: grid;
	border: 1px solid var(--pce-widget-border);
	grid: auto / 1em auto;
	gap: 0.3em;
	padding: 0.3em;
	border-radius: 0.3em;
	margin: -99in 0 0 0;
	line-height: 1.5;
	color: var(--pce-widget-color);
	background: var(--pce-widget-bg);
	position: sticky;
	top: 0.5em;
	right: 0.5em;
	left: 0.5em;
	z-index: 4;
	pointer-events: auto;
}

.prism-search-container * {
	box-sizing: border-box;
}

.prism-search button {
	all: unset;
	cursor: pointer;
}

.pce-readonly .prism-search {
	grid: auto / auto;
}

.prism-search > div > div {
	display: flex;
}

.pce-input input {
	padding: 0 0 0 0.3em;
	width: calc(var(--search-width, 20em) - 10ch - 4px);
	font: inherit;
	border: none;
	background: #0000;
	color: var(--pce-widget-color);
	outline: 0;
}

.pce-input ::placeholder {
	color: inherit;
	opacity: 0.6;
}

.pce-match-count {
	margin: 1px auto 1px 0;
}

.pce-match-count,
.pce-input {
	font-family: Arial, Helvetica, sans-serif;
}

.pce-options {
	color: var(--pce-widget-color-options);
	font-size: 80%;
	gap: 0.25em;
}

.pce-options button {
	padding: 0 0.2em;
	border-radius: 0.2em;
	width: 1.2em;
	text-align: center;
}

.pce-options button span {
	pointer-events: none;
}

.prism-search button:focus-visible {
	outline: 1px solid var(--pce-widget-focus);
	z-index: 1;
}

.pce-input,
.pce-options button {
	box-shadow: 0 0 0 1px var(--_border, var(--pce-widget-border));
	margin: 1px;
}

.pce-input {
	display: flex;
	position: relative;
	background: var(--pce-widget-bg-input);
	border-radius: 0.15em;
	height: 1.5em;
}

.pce-input:focus-within {
	--_border: var(--pce-widget-focus);
}

.pce-find button {
	display: grid;
	align-items: center;
	padding: 0 0.4em;
}

.pce-replace button {
	width: 7.3ch;
	text-align: center;
}

.pce-replace :last-child {
	width: 2.7ch;
}

.pce-input button {
	box-shadow: -1px 0 0 0 var(--pce-widget-border);
	margin-left: 1px;
}

.pce-prev::before {
	transform: rotate(-90deg);
}

.pce-next::before,
.pce-expand::before {
	transform: rotate(90deg);
}

@media (hover: hover) {
	.prism-search button:hover {
		background: var(--pce-widget-bg-hover);
	}
}

.pce-options button[aria-pressed="true"] {
	background: var(--pce-widget-bg-active);
	color: var(--pce-widget-color-active);
	--_border: var(--pce-widget-focus);
}

.pce-input > :nth-child(3) {
	border-radius: 0 0.15em 0.15em 0;
}

.pce-input.pce-error {
	--_border: var(--pce-widget-error);
	--pce-widget-focus: var(--_border);
}

.search-error {
	display: none;
	position: absolute;
	top: 100%;
	box-shadow: inherit;
	width: 100%;
	white-space: normal;
	word-break: break-word;
	left: 0;
	background: var(--pce-widget-bg-error);
	padding: 0.5em;
	z-index: 1;
}

.pce-error:focus-within .search-error {
	display: block;
}

button.pce-close {
	display: grid;
	width: 1.3em;
	height: 1.3em;
	place-items: center;
	margin-left: auto;
	border-radius: 0.3em;
}

.pce-find button::before,
.pce-expand::before,
.pce-close::before {
	content: "";
	background: currentColor;
	height: 1.2em;
	opacity: 0.75;
}

.pce-close::before {
	clip-path: polygon(
		50% 44.34%,
		0% 74.34%,
		9.43% 80%,
		9.43% 20%,
		0% 25.66%,
		50% 55.66%,
		100% 25.66%,
		90.57% 20%,
		50% 44.34%,
		9.43% 20%,
		9.43% 80%,
		50% 55.66%,
		90.57% 80%,
		100% 74.34%
	);
	width: 0.72em;
}

.prism-search > div {
	display: grid;
	gap: 0.25em;
	width: var(--search-width, 20em);
}

button.pce-expand {
	display: grid;
	place-items: center;
	border-radius: 0.25em;
	margin: -0.15em;
}

.pce-readonly .pce-expand,
[aria-expanded="false"] + div .pce-replace,
.pce-readonly .pce-replace {
	display: none;
}

.pce-expand[aria-expanded="true"]::before {
	transform: rotate(180deg);
}

.pce-find button::before,
.pce-expand::before {
	width: 0.84em;
	clip-path: polygon(50% 28.96%, 0% 63.96%, 10.1% 71.04%, 50% 43.11%, 89.9% 71.04%, 100% 63.96%);
}

button.pce-regex {
	display: flex;
}

.pce-regex span {
	display: flex;
	align-items: flex-end;
}

.pce-regex span::before {
	content: "";
	width: 0.3em;
	height: 0.3em;
	background: currentColor;
	margin: 0 0 0.2em 0.1em;
}

.pce-regex span::after {
	content: "*";
	line-height: 0;
	font-size: 140%;
	margin-bottom: 0.5em;
}

button.pce-in-selection {
	display: grid;
	place-items: center;
}

button.pce-whole {
	position: relative;
}

.pce-whole::after {
	content: "";
	position: absolute;
	bottom: 0.31em;
	right: 0.27em;
	left: 0.27em;
	height: 0.25em;
	clip-path: inset(1px -1px -1px);
	box-shadow: 0 0 0 1px;
}

.pce-in-selection::before {
	content: "";
	height: 80%;
	width: 90%;
	background: currentColor;
	clip-path: polygon(
		0 16%,
		80% 16%,
		80% 24%,
		0 24%,
		0 46%,
		100% 46%,
		100% 54%,
		0 54%,
		0 76%,
		60% 76%,
		60% 84%,
		0 84%
	);
}

.pce-matches span {
	background: var(--pce-search-match);
}

.pce-matches :empty {
	padding: 0 2px;
	margin: 0 -2px;
}
